import FeatureFlag from 'domain/entity/featureFlag';
import getGenericUseCase, { GetUseCase } from 'use-case/genericUseCase';
import ReadFeatureFlagCriteria from 'use-case/featureFlags/read/readFeatureFlagCriteria';

export type ReadFeatureFlag = GetUseCase<FeatureFlag, ReadFeatureFlagCriteria>;

const readFeatureFlagUseCase = getGenericUseCase<FeatureFlag, ReadFeatureFlagCriteria>((client, criteria) => client(criteria));

export default readFeatureFlagUseCase;
